import { DatepickerModalPage } from 'src/app/pages/datepicker-modal/datepicker-modal.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: DatepickerModalPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DatepickerModalPageRoutingModule {}
